var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-content code"},[_c('div',{staticClass:"text-center py-4",domProps:{"innerHTML":_vm._s(_vm.viewerError)}})])}
var staticRenderFns = []

export { render, staticRenderFns }